import styles from '.././PointOfSaleManager.module.scss'
import modalStyles from './ModalTitleBar.module.scss'

interface ModalTitleBarProps {
    close(): void
    title: string
}

const ModalTitleBar = ({ close, title }: ModalTitleBarProps) => {
    return (
        <div className={styles.modalTitleBar}>
            <div className={modalStyles.ModalTitleHeader}>
                <div className={modalStyles.lineItemNotesModalTitle}>{title}</div>
                <div onClick={close} className={'a-i-close'} />
            </div>
            <div className={'a-divider'} style={{ marginBottom: 15,width:'auto' }} />
        </div>
    )
}

export default ModalTitleBar
